import { CommonModule } from '@angular/common';
import { Component, Signal } from '@angular/core';
import { SpinnerService } from '@app/shared/services/spinner.service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  loading: Signal<boolean>;

  constructor(public spinnerService: SpinnerService) {
    this.loading = spinnerService.loading;
  }
}
